export class MediaBoxes {
    init() {
        let gridElement = document.getElementById('grid');

        if (typeof(gridElement) != 'undefined' && gridElement != null) {
            let mediaBoxImages = document.querySelectorAll('.media-box-image > div[data-image-mobile]'),
                mediaBoxSliders = document.querySelectorAll('.master-slider'),
                carousels = document.querySelectorAll('.carousel-container');

            onresize = (event) => {
                this.handleMediaBoxImages(mediaBoxImages, mediaBoxSliders);
            };

            onload = (event) => {
                this.handleMediaBoxImages(mediaBoxImages, mediaBoxSliders);
            }
            this.handleMediaBoxImages(mediaBoxImages, mediaBoxSliders);
        }
    }

    handleMediaBoxImages(mediaBoxImages, mediaBoxSliders) {
        if (window.matchMedia('(max-width: 1024px)').matches) {
            mediaBoxImages.forEach(el => {
                el.firstChild.src = el.dataset.imageMobile;
            });

            mediaBoxSliders.forEach(el => {
                if (el.querySelector('.image-mobile')) {
                    el.firstElementChild.style.display = 'none';
                }
            });
        } else {
            mediaBoxImages.forEach(el => {
                el.firstChild.src = el.dataset.thumbnail;
            });

            mediaBoxSliders.forEach(el => {
                if (el.querySelector('.image-mobile')) {
                    el.firstElementChild.style.display = 'initial';
                }
            });
        }
    }
}
